// Remembers a friend's referral code from a share link (easyfile2290.com/?ref=CODE) until the
// visitor signs up, so the code survives browsing the blog/calculators first. Only a code the
// API confirmed exists is stored (see ReferralCapture). Browser storage can be unavailable
// (private mode, blocked site data) - then there is simply no remembered code.

const KEY = "ef2290.ref";
// A link clicked more than 60 days before signing up no longer counts.
const MAX_AGE_MS = 60 * 24 * 60 * 60 * 1000;
const CODE_RE = /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{8}$/;

export function normalizeReferralCode(raw) {
  const code = (raw || "").trim().toUpperCase();
  return CODE_RE.test(code) ? code : null;
}

export function rememberReferralCode(code) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }));
  } catch {
    /* storage unavailable - the referral just isn't remembered */
  }
}

export function getRememberedReferralCode() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, at } = JSON.parse(raw);
    if (!normalizeReferralCode(code) || typeof at !== "number" || Date.now() - at > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function forgetReferralCode() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nothing to forget */
  }
}

// The public link a filer shares: this build's own site (REACT_APP_SHARE_SITE_URL in .env,
// .env.uat, .env.production), so a UAT share link opens UAT, not the live site. Deliberately
// not SITE.url - that stays the live domain for canonicals, sitemap and schema on every build.
// No fallback: a build without it must not quietly share the live address.
const SHARE_SITE_URL = process.env.REACT_APP_SHARE_SITE_URL;

// campaign: "in-app" for the signed-in share box, "page-share" for the public share row.
export function shareUrl(path, { code, medium, campaign = "in-app" }) {
  const params = new URLSearchParams();
  if (code) params.set("ref", code);
  params.set("utm_source", "share");
  params.set("utm_medium", medium);
  params.set("utm_campaign", campaign);
  if (!SHARE_SITE_URL) {
    throw new Error("REACT_APP_SHARE_SITE_URL is not set for this build - share links have no site address.");
  }
  return `${SHARE_SITE_URL}${path}?${params.toString()}`;
}
